module.exports = __webpack_public_path__ + "img/shedBg.d1e5d35d.png";